// import { createClient } from '@base44/sdk'; // Removed deprecated import
import { appParams } from '@/lib/app-params';

const { appId, serverUrl, token, functionsVersion } = appParams;

// DEPRECATED: Base44 client kept for backward compatibility during migration
// TODO: Remove after full migration to Supabase
// Create stub object to prevent crashes during migration

const createDeprecationError = (method, replacement) => {
  const error = new Error(`🚫 Base44 ${method} is deprecated - use ${replacement}`);
  console.error('❌ DEPRECATED BASE44 CALL:', {
    method,
    replacement,
    stack: error.stack
  });
  return error;
};

export const base44 = {
  entities: {
    Report: {
      list: () => {
        console.warn('⚠️ Base44 Report.list() called - returning empty array. Use reportsService.list()');
        return Promise.resolve([]);
      },
      filter: () => {
        console.warn('⚠️ Base44 Report.filter() called - returning empty array. Use reportsService.filter()');
        return Promise.resolve([]);
      },
      create: () => Promise.reject(createDeprecationError('Report.create()', 'reportsService.create()')),
      update: () => Promise.reject(createDeprecationError('Report.update()', 'reportsService.update()')),
      delete: () => Promise.reject(createDeprecationError('Report.delete()', 'reportsService.delete()')),
    },
    Comment: {
      list: () => {
        console.warn('⚠️ Base44 Comment.list() called - returning empty array. Use commentsService.list()');
        return Promise.resolve([]);
      },
      filter: () => {
        console.warn('⚠️ Base44 Comment.filter() called - returning empty array. Use commentsService.filter()');
        return Promise.resolve([]);
      },
      create: () => Promise.reject(createDeprecationError('Comment.create()', 'commentsService.create()')),
    },
    Upvote: {
      list: () => {
        console.warn('⚠️ Base44 Upvote.list() called - returning empty array. Use upvotesService.list()');
        return Promise.resolve([]);
      },
      filter: () => {
        console.warn('⚠️ Base44 Upvote.filter() called - returning empty array. Use upvotesService.filter()');
        return Promise.resolve([]);
      },
      create: () => Promise.reject(createDeprecationError('Upvote.create()', 'upvotesService.toggle()')),
      delete: () => Promise.reject(createDeprecationError('Upvote.delete()', 'upvotesService.toggle()')),
    },
    Task: {
      list: () => {
        console.warn('⚠️ Base44 Task.list() called - returning empty array. Use tasksService.list()');
        return Promise.resolve([]);
      },
      filter: () => {
        console.warn('⚠️ Base44 Task.filter() called - returning empty array. Use tasksService.filter()');
        return Promise.resolve([]);
      },
      create: () => Promise.reject(createDeprecationError('Task.create()', 'tasksService.create()')),
      update: () => Promise.reject(createDeprecationError('Task.update()', 'tasksService.update()')),
    },
    Query: {}
  },
  integrations: {
    Core: {
      UploadFile: () => Promise.reject(createDeprecationError('Core.UploadFile()', 'storageService.uploadFile()')),
      InvokeLLM: () => Promise.reject(createDeprecationError('Core.InvokeLLM()', 'OpenAI/Anthropic API directly')),
      SendEmail: () => Promise.reject(createDeprecationError('Core.SendEmail()', 'email service')),
      SendSMS: () => Promise.reject(createDeprecationError('Core.SendSMS()', 'SMS service')),
      GenerateImage: () => Promise.reject(createDeprecationError('Core.GenerateImage()', 'image generation API')),
      ExtractDataFromUploadedFile: () => Promise.reject(createDeprecationError('Core.ExtractDataFromUploadedFile()', 'file parsing library')),
    }
  },
  auth: {
    me: () => {
      const error = createDeprecationError('auth.me()', 'useAuth() hook');
      return Promise.reject(error);
    },
    updateMe: () => Promise.reject(createDeprecationError('auth.updateMe()', 'usersService.updateMe()')),
    redirectToLogin: () => {
      console.error('❌ DEPRECATED: Base44 redirectToLogin() called - use navigate("/Login") instead');
      console.trace('Call stack:');
    },
  },
  appLogs: {
    logUserInApp: (pageName) => {
      console.debug('⚠️ Base44 appLogs.logUserInApp() called - skipping. Page:', pageName);
      return Promise.resolve(); // Silently succeed
    },
  }
};

// Export the actual services from the services folder
export { reportsService } from '@/services/reports';
export { commentsService } from '@/services/comments';
export { upvotesService } from '@/services/upvotes';
export { tasksService } from '@/services/tasks';
export { usersService } from '@/services/users';
export { storageService } from '@/services/storage';

// Uncomment if you need the real Base44 client temporarily
// export const base44 = createClient({
//   appId,
//   serverUrl,
//   token,
//   functionsVersion,
//   requiresAuth: false,
//   appBaseUrl: serverUrl
// });
